import React from "react";
import Footer from "./components/Footer";
import "../css/About.css"; // reuse same frosted styling
import { clearBasket } from "./code/basket";

function Success() {
  clearBasket();
  return (
    <section className="about frosted">
      <h2>ORDER CONFIRMED //</h2>
      <h3>Thank you for your order!</h3>
      <br />
      <div className="about-text">
        <p>Your order has been received and is being prepared for you :)</p>
        <p>
          Delivery will take between 5-10 business days.
        </p>
        <p>
          Each print is packaged with care — thank you for supporting our fun little project and being part of the COUSCOUS journey.
        </p>
        <br />
        <p>Lots of love,</p>
        <p>Holly, Issy, Leah</p>
        <p>X</p>
      </div>
      <br />
      <br />
      <Footer />
    </section>
  );
}

export default Success;
